export default "__VITE_ASSET__vojzGSfL__"